import { MonacoEditor } from '../../../CodeEditor/MonacoEditor'
import { FormBuilderSchema } from '../../../FormBuilderCore/Types'

type FormBuilderStyleSectionProps = {
	schemaReference: FormBuilderSchema
	onSchemaModified: (schema: FormBuilderSchema) => void
}

export const FormBuilderStyleSection = (
	props: FormBuilderStyleSectionProps,
) => {
	return (
		<>
			<MonacoEditor
				language="css"
				value={props.schemaReference.style ?? ''}
				onChange={(v) => {
					props.onSchemaModified({ ...props.schemaReference, style: v })
				}}
				height="100vh"
				width="100vh"
			/>
		</>
	)
}
